import { useCallback } from 'react';

import useInternalContext from '/druid/internal/useInternalContext';

export default function useItemContainerCallbackRef() {
  const { itemContainerCallbackRefWithSubscribe } = useInternalContext();

  return useCallback(
    element => itemContainerCallbackRefWithSubscribe(element),
    [itemContainerCallbackRefWithSubscribe]
  );
}
